import React ,{useEffect,useState} from 'react'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {http_request} from '../../../../utils/http_request'
import {endpoint} from '../../../../config'
import ErrorLoadingText from '../../../../utils/error-loading-text'
import DataComp from './data-comp'
import Container from '@material-ui/core/Container';

import authentication from '../../components/authentication'
const useStyles = makeStyles((theme) => ({

  paper: {
    minHeight:400,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },


}));

export default( )=>{
  const classes = useStyles();
    const [loader, toggleLoader] = useState(true);
  const[submitLoader,toggleSubmitLoader]=useState(false)
const[error,setError]=useState(null)
const[data,setData]=useState(null)
  useEffect(() => {

    async function fetchData() {
      try{
         const data=  await http_request({endpoint:endpoint,service:'query-orders',variables:`token=${authentication()}`});
console.log(data)
 setData(data.data)
       }
       catch(e){
setError(e)
       }
       finally{
         toggleLoader(false)
       }
     }

           fetchData();
       },[]
    );

  return(

<Container>
<br /><br />
<Typography component="h2" variant="h5" align="center">
            Application Forms
            </Typography>
         <br />
{loader && <ErrorLoadingText>Loading...</ErrorLoadingText>}
{error && <ErrorLoadingText>{error.message}</ErrorLoadingText>}
{data && <DataComp data={data} toggleSubmitLoader={toggleSubmitLoader}/>}

</Container>

  )
}
